import {
  WSActions,
  WSCard,
  WSDataItem,
  WSElement,
  WSForm,
  WSInputDate,
  WSInputText,
  WSList,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { useWSMutation } from "@ws-react-query";

import { useUserId } from "../../../../query/hooks/helpers";
import { useQueryCustomerEntity } from "../../../../query/onboarding/queries/useQueryCustomerEntity";
import {
  useQueryMemberProfile,
  useQueryUserProfile
} from "../../../../query/users/queries";
import { entityDataService } from "../../../../shared/services/entityData";
import { WSServiceError } from "../../../../utils/serviceHelper";
import {
  FormDataAddress,
  FormPartialAddress
} from "../../../Onboarding/components/FormPartialAddress";

import { FlowStep } from "../../../../shared/components/FlowSwitch/types";

type FormData = {
  firstName: string;
  lastName: string;
  dob: Date;
  address: FormDataAddress;
};

export const StepInformation: React.FC<FlowStep> = props => {
  const userId = useUserId();
  const queryCustomerEntity = useQueryCustomerEntity();
  const queryUser = useQueryUserProfile(userId);
  const queryMember = useQueryMemberProfile(userId);

  const [mutate, meta] = useWSMutation<void, WSServiceError, FormData>(
    async data => {
      await entityDataService.updateEntity(
        {
          firstName: data.firstName,
          lastName: data.lastName,
          dateOfBirth: data.dob,
          address: data.address
        },
        {
          userId
        }
      );
    },
    {
      onSuccess: props.onNext
    }
  );

  return (
    <WSForm<FormData>
      defaultValues={{
        firstName: queryUser.data?.profile.firstName,
        lastName: queryUser.data?.profile.lastName,
        dob: queryUser.data?.profile.dob,
        address: queryMember.data?.profile.address
      }}
      onSubmit={values => {
        mutate(values);
      }}
    >
      <WSList gap="2XL">
        <WSElement>
          <WSSectionToolbar title="Confirm your information" />
          <WSText.ParagraphSm color="gray500">
            Confirm your information to enroll in Premium Perks and receive your
            welcome packet.
          </WSText.ParagraphSm>
        </WSElement>

        <WSCard>
          <WSList gap="L">
            <WSDataItem label="Email" value={queryUser.data?.email} />

            <WSList equalItems gap="XL" kind="Horizontal">
              <WSForm.Field
                component={WSInputText}
                componentProps={{
                  required: true,
                  disabled: !!queryCustomerEntity.data
                }}
                label="First name"
                name="firstName"
              />
              <WSForm.Field
                component={WSInputText}
                componentProps={{
                  required: true,
                  disabled: !!queryCustomerEntity.data
                }}
                label="Last name"
                name="lastName"
              />
            </WSList>

            <WSForm.Field
              component={WSInputDate}
              componentProps={{
                required: true,
                disabled: !!queryCustomerEntity.data
              }}
              label="Date of birth"
              name="dob"
            />
          </WSList>
        </WSCard>

        <WSCard header="Address">
          <FormPartialAddress country="US" name="address" />
        </WSCard>

        <WSActions
          alignment="fill"
          buttons={[
            {
              label: "Continue to payment",
              loading: meta.isLoading
            }
          ]}
        />
      </WSList>
    </WSForm>
  );
};
